var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1486_3323)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6667 22.2L21.3329 20.65L24.0003 19.1L26.6664 17.55V23.75L24.0003 25.3L21.3329 26.85L18.6667 28.4L16.0006 29.95L13.3345 31.5H13.3332L10.6671 29.95L8.00095 28.4L5.33354 26.85L2.66741 25.3H2.66613L0 23.75V8.25L2.66613 6.7H2.66741L5.33354 5.15L7.99967 3.6H8.00095L10.6671 2.05L13.3332 0.5H13.3345L16.0006 2.05L18.6667 3.6L16.0006 5.15L13.3345 6.7L10.6671 8.25L8.00095 9.8L5.33354 11.35V17.55L8.00095 16L10.6671 14.45L13.3345 12.9L16.0006 11.35L18.6667 9.8L21.3329 11.35V14.45L18.6667 16L16.0006 17.55L13.3345 19.1L10.6671 20.65L8.00095 22.2L10.6671 23.75L13.3345 25.3L16.0006 23.75L18.6667 22.2ZM29.144 3.49021L31.8114 5.04021L32 5.15V14.45L30.7285 15.1901L26.6665 17.55V8.25L26.2662 8.0175L24.0004 6.7L21.5446 5.27271L21.3329 5.15L20.9326 4.9175L18.6668 3.6L21.5511 1.92342L24.0004 0.5L26.4779 1.94021L26.6665 2.05L29.144 3.49021Z",
    fill: "url(#paint0_linear_1486_3323)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1486_3323",
    x1: 0.0295694,
    y1: 23.6208,
    x2: 32.0824,
    y2: 5.40004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D9764"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29913"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1486_3323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/small_logo.434f133e64f34ea6ff4be4fb42cc2e13.svg";
export { ForwardRef as ReactComponent };